import React, { useMemo } from "react";

import TiktokCreateDest from "pages/Destinations/TiktokCreateDest";

import CreateTikTokDestination from "components/CreateTikTokDestination";

import OrDivider from "../OrDivider";

/** TikTok OAuth, then advertiser pixel / offline event set selection. */
const TiktokDestinationForm = ({
    language,
    destinationCode,
    tiktok,
    oauthData,
    setOauthData,
}) => {
    const form = useMemo(
        () => ({ destinations: destinationCode }),
        [destinationCode],
    );

    return (
        <div>
            {!tiktok.hasAccess && (
                <CreateTikTokDestination
                    form={form}
                    tiktokAccess={tiktok.hasAccess}
                    setTiktokAccess={tiktok.setHasAccess}
                    isAuthData={oauthData}
                    setIsAuthData={setOauthData}
                    setOfflineData={tiktok.setOfflineData}
                    offlineData={tiktok.offlineData}
                />
            )}
            {tiktok.hasAccess && (
                <TiktokCreateDest
                    authData={oauthData ?? []}
                    tiktokOfflineData={tiktok.offlineData}
                    selectedType={destinationCode}
                    selectedValues={tiktok.selectedValues}
                    setSelectedValues={tiktok.setSelectedValues}
                    pixelsOption={tiktok.pixelsOption}
                    setPixelsOption={tiktok.setPixelsOption}
                />
            )}
            {!tiktok.hasAccess && <OrDivider language={language} />}
        </div>
    );
};

export default TiktokDestinationForm;
